import { render, staticRenderFns } from "./TCs.vue?vue&type=template&id=ad293ea0"
import script from "./TCs.vue?vue&type=script&lang=js"
export * from "./TCs.vue?vue&type=script&lang=js"
import style0 from "./TCs.vue?vue&type=style&index=0&id=ad293ea0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports